class SubVariantTabs extends HTMLElement {
  constructor() {
    super()

    this.subsTabToggle = this.querySelector('[data-tab-toggle="subs"]')
    this.oneTimeTabToggle = this.querySelector('[data-tab-toggle="one-time"]')

    this.subsTab = this.querySelector('[data-tab="subs"]')
    this.oneTimeTab = this.querySelector('[data-tab="one-time"]')

    this.subsSelect = this.querySelector('[data-subs-select]')

    this.sellingPlan = document.querySelector('input[name="selling_plan"]')

    this.lastSellingPlan = this.sellingPlan.value

    // console.log(this.lastSellingPlan)

    this.sellingPlan.disabled = false

    this.activeTab = null

    if(this.subsTabToggle && this.subsTab && this.subsSelect) {

      this.activeTab = this.oneTimeTab
      this.sellingPlan.value = '';

      this.subsTabToggle.addEventListener('click', this.handleTabChange)
      this.oneTimeTabToggle.addEventListener('click', this.handleTabChange)

      this.subsSelect.addEventListener('change', this.handlePlanChange)

      // preselect subscription tab if option=subscription is in the URL
      // if(window.location.search.includes('option=subscription')) {
      // !!!!!!!!!!!!! - currently preselected by default on all products - !!!!!!!!!!!!!
      this.subsTabToggle.click()
      // }
    }


  }

  handleTabChange = (e) => {

    e.currentTarget.disabled = true

    this.activeTab.classList.remove('active')

    const activeVariant = this.activeTab.querySelector('input:checked')

    // console.log(activeVariant)

    if(this.activeTab == this.subsTab) {

      this.subsTabToggle.disabled = false

      this.activeTab = this.oneTimeTab

      this.sellingPlan.value = ''

    }
    else if(this.activeTab == this.oneTimeTab) {

      this.oneTimeTabToggle.disabled = false

      this.activeTab = this.subsTab

      this.sellingPlan.value = this.lastSellingPlan

    }

    console.log('handleTabChange: ' + this.lastSellingPlan)

    const syncActiveVariant = this.activeTab.querySelector(`input[value="${activeVariant.value}"]`)

    if (syncActiveVariant) {
      syncActiveVariant.checked = true
    }

    this.activeTab.classList.add('active')

  }

  handlePlanChange = (e, plan) => {

    this.sellingPlan.value = e.target.value
    this.lastSellingPlan = e.target.value

    console.log('handlePlanChange: ' + this.lastSellingPlan)

  }


}
customElements.define('sub-variant-tabs', SubVariantTabs)